import { Menu, Dropdown } from 'antd';
import UzbImage from "assets/images/uzb-flag.png"
import RusImage from "assets/images/rus-flag.jpg"
import EnImage from "assets/images/en-flag.jpg"
import { FC, useState } from "react";
import i18n from 'config/i18n';
import "./styles.scss";
import { SelectStudentTheme } from 'config/theme/colors';

const LanguageBtn: FC<any> = (props): JSX.Element => {
    const langs = [
        {
            id: 1,
            title: "Uzbek",
            key: "uz",
            img: UzbImage
        },
        {
            id: 3,
            title: "Ruscha",
            key: "ru",
            img: RusImage
        },
        {
            id: 4,
            title: "Ingliz",
            key: "en",
            img: EnImage
        },
    ]

    const localLang = localStorage.getItem("i18lang") ? langs.find(i => i.key === localStorage.getItem("i18lang")) : langs[0]
    const [selectedItem, setselectedItem] = useState(localLang)

    const theme = SelectStudentTheme();

    const changeLang = (event: any) => {
        localStorage.setItem("i18lang", event.key)
        setselectedItem(event)
        i18n.changeLanguage(event.key)
    }

    const menu = (
        <Menu style={{zIndex: 1000}} items={langs.map((item: any) => (
            {
                key: item.key,
                label: item.title,
                icon: <img className="student_language_img" src={item.img} alt={item.key} />,
            }
        ))}>
        </Menu>
    );
    return (
        <Dropdown className='mx-2' overlay={menu} trigger={['click']} overlayStyle={{ backgroundColor: 'green'}}>
            <div className="header_language student_header_language" style={{ backgroundColor: theme.element, cursor: 'pointer' }}>
                <img className="header_language_img" src={selectedItem?.img} alt="?" />&nbsp;
                <span style={{ color: theme.blue }}>{selectedItem?.title}</span>
            </div>
        </Dropdown>
    )
}

export default LanguageBtn;